import builder from '../builder';
import ArrowButtonRight from '../../streamline-icons/bold/arrow-button-right.svg';

export default builder('IconArrowButtonRightBold', ArrowButtonRight);
